import { createUseStyles } from 'react-jss';

export const useMessageBarStyle = createUseStyles({
    infoCard: {
        marginTop: '12px',
    },
});
